<template lang="html">
<div>
  <strong class="text-muted d-block my-2">{{title}}</strong>
  <d-form-row>
    <!-- Title -->
    <d-col cols="12" md="8" class="form-group">
      <label for="feTitle">Nome do {{title}}</label>
      <d-form-input
        :state="hasErrorFiled('contacts_name')"
        type="text"
        v-model="model.name"
        id="feTitle"
        :placeholder="title"
        @change="capitalizeInput"
      />
    </d-col>

  </d-form-row>

  <d-form-row>

    <!-- CPF & RG -->
    <d-col cols="12" md="6" class="form-group">
      <d-form-row>
        <!-- CPF -->
        <d-col class="form-group">
          <label for="feCPF">CPF</label>
          <masked-input
            type="text"
            class="text-left form-control"
            id="feCPF"
            placeholder="000.000.000-00"
            :mask="[/\d/, /\d/, /\d/,'.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]"
            :guide="false"
            v-model="model.document"
          ></masked-input>
        </d-col>
        <!-- RG -->
        <d-col class="form-group">
          <label for="feRG">RG</label>
          <input-general-register :model.sync="model.general_register"/>
        </d-col>
      </d-form-row>
    </d-col>
    <!-- Email -->
    <d-col md="3" class="form-group">
      <label for="feContactEmail">E-mail ({{title}})</label>
      <d-form-input type="email" v-model="model.email" id="feContactEmail" placeholder="E-mail"/>
    </d-col>

    <!-- Telefone -->
    <d-col md="3" class="form-group">
      <label for="feTelefone">Telefone (Whatsapp)</label>
      <input-phone
        id="feTelefone"
        placeholder="Telefone"
        :model.sync="model.phone"
      ></input-phone>
    </d-col>
  </d-form-row>
</div>
</template>

<script>
import InputPhone from '_shared/InputPhone.vue';
import MaskedInput from 'vue-text-mask';
import mixin from '_common/mixins/ValidateForm';
import InputGeneralRegister from '_shared/InputGeneralRegister.vue';
import { capitalize } from '_utils';

export default {
  name: 'contact-form',
  props: {
    title: {
      type: String,
      default: 'Contato',
    },
    model: {
      type: Object,
    },
  },
  mixins: [mixin],
  components: {
    InputPhone,
    MaskedInput,
    InputGeneralRegister,
  },
  computed: {},
  watch: {},
  methods: {
    capitalizeInput() {
      this.model.name = capitalize(this.model.name);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
